import React from "react";
import Nomenklatury2 from "../../components/spravochniki/nomenklatura2/Nomenklatury2";

function Nomenklatury2Page(props) {
  return (
    <>
      <Nomenklatury2 />
    </>
  );
}

export default Nomenklatury2Page;